<template>
  <ul class="list">
    <template
      v-for="(item, i) in cleanList"
      :key="i"
    >
      <li
        class="list__element list__element--dashed unstyled-html"
        v-html="replaceFootnotes(highlightRenderer(item))"
      />
    </template>
  </ul>
</template>

<script setup lang="ts">
import { replaceFootnotes } from '@i22team/rocket';
import highlightRenderer from '~/lib/highlight-renderer';

export type BulletPointListProps = {
  list?: (string | null | undefined)[] | undefined | null;
};

const props = withDefaults(defineProps<BulletPointListProps>(), {
  list: undefined,
});

const cleanList = computed(() => props.list?.filter(Boolean) || []);
</script>
